// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.remove-button[data-v-40f56c84]{\n\t-ms-flex-negative: 0;\n\t    flex-shrink: 0;\n\t-webkit-box-flex: 0;\n\t    -ms-flex-positive: 0;\n\t        flex-grow: 0;\n}\n.shrink[data-v-40f56c84]{\n\t-ms-flex-negative: 1;\n\t    flex-shrink: 1;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
